import http from './http';

export function fetchCaptcha() {
  return http.get('/auth/captcha');
}

export function login(email, password, captchaId, captchaCode) {
  return http.post('/auth/login', {
    email,
    password,
    captchaId,
    captchaCode
  });
}

export function register(email, password, captchaId, captchaCode, inviteCode) {
  return http.post('/auth/register', {
    email,
    password,
    captchaId,
    captchaCode,
    inviteCode
  });
}

export function fetchDomainInfo(domain) {
  return http.get('/auth/domain', { params: { domain } });
}

export function sendPasswordResetCode(email, captchaId, captchaCode) {
  return http.post('/auth/password-reset/send-code', {
    email,
    captchaId,
    captchaCode
  });
}

export function resetPassword(email, emailCode, newPassword) {
  return http.post('/auth/password-reset', {
    email,
    emailCode,
    newPassword
  });
}
